/**
 * Complete list of ISO 639-2/3 languages with metadata
 */

export const ALL_LANGUAGES = [
  // Major world languages
  { code: "ara", name: "Arabic", native_name: "العربية", script: "Arabic", direction: "rtl" },
  { code: "ben", name: "Bengali", native_name: "বাংলা", script: "Bengali", direction: "ltr" },
  { code: "zho", name: "Chinese (Mandarin)", native_name: "普通话", script: "Han", direction: "ltr" },
  { code: "yue", name: "Chinese (Cantonese)", native_name: "廣東話", script: "Han", direction: "ltr" },
  { code: "eng", name: "English", native_name: "English", script: "Latin", direction: "ltr" },
  { code: "fra", name: "French", native_name: "Français", script: "Latin", direction: "ltr" },
  { code: "deu", name: "German", native_name: "Deutsch", script: "Latin", direction: "ltr" },
  { code: "hin", name: "Hindi", native_name: "हिन्दी", script: "Devanagari", direction: "ltr" },
  { code: "ind", name: "Indonesian", native_name: "Bahasa Indonesia", script: "Latin", direction: "ltr" },
  { code: "ita", name: "Italian", native_name: "Italiano", script: "Latin", direction: "ltr" },
  { code: "jpn", name: "Japanese", native_name: "日本語", script: "Japanese", direction: "ltr" },
  { code: "kor", name: "Korean", native_name: "한국어", script: "Hangul", direction: "ltr" },
  { code: "por", name: "Portuguese", native_name: "Português", script: "Latin", direction: "ltr" },
  { code: "rus", name: "Russian", native_name: "Русский", script: "Cyrillic", direction: "ltr" },
  { code: "spa", name: "Spanish", native_name: "Español", script: "Latin", direction: "ltr" },
  { code: "tur", name: "Turkish", native_name: "Türkçe", script: "Latin", direction: "ltr" },
  { code: "vie", name: "Vietnamese", native_name: "Tiếng Việt", script: "Latin", direction: "ltr" },
  
  // European languages
  { code: "bul", name: "Bulgarian", native_name: "Български", script: "Cyrillic", direction: "ltr" },
  { code: "cat", name: "Catalan", native_name: "Català", script: "Latin", direction: "ltr" },
  { code: "hrv", name: "Croatian", native_name: "Hrvatski", script: "Latin", direction: "ltr" },
  { code: "ces", name: "Czech", native_name: "Čeština", script: "Latin", direction: "ltr" },
  { code: "dan", name: "Danish", native_name: "Dansk", script: "Latin", direction: "ltr" },
  { code: "nld", name: "Dutch", native_name: "Nederlands", script: "Latin", direction: "ltr" },
  { code: "est", name: "Estonian", native_name: "Eesti", script: "Latin", direction: "ltr" },
  { code: "fin", name: "Finnish", native_name: "Suomi", script: "Latin", direction: "ltr" },
  { code: "ell", name: "Greek", native_name: "Ελληνικά", script: "Greek", direction: "ltr" },
  { code: "hun", name: "Hungarian", native_name: "Magyar", script: "Latin", direction: "ltr" },
  { code: "isl", name: "Icelandic", native_name: "Íslenska", script: "Latin", direction: "ltr" },
  { code: "gle", name: "Irish", native_name: "Gaeilge", script: "Latin", direction: "ltr" },
  { code: "lav", name: "Latvian", native_name: "Latviešu", script: "Latin", direction: "ltr" },
  { code: "lit", name: "Lithuanian", native_name: "Lietuvių", script: "Latin", direction: "ltr" },
  { code: "mkd", name: "Macedonian", native_name: "Македонски", script: "Cyrillic", direction: "ltr" },
  { code: "mlt", name: "Maltese", native_name: "Malti", script: "Latin", direction: "ltr" },
  { code: "nor", name: "Norwegian", native_name: "Norsk", script: "Latin", direction: "ltr" },
  { code: "pol", name: "Polish", native_name: "Polski", script: "Latin", direction: "ltr" },
  { code: "ron", name: "Romanian", native_name: "Română", script: "Latin", direction: "ltr" },
  { code: "srp", name: "Serbian", native_name: "Српски", script: "Cyrillic", direction: "ltr" },
  { code: "slk", name: "Slovak", native_name: "Slovenčina", script: "Latin", direction: "ltr" },
  { code: "slv", name: "Slovenian", native_name: "Slovenščina", script: "Latin", direction: "ltr" },
  { code: "swe", name: "Swedish", native_name: "Svenska", script: "Latin", direction: "ltr" },
  { code: "ukr", name: "Ukrainian", native_name: "Українська", script: "Cyrillic", direction: "ltr" },
  { code: "cym", name: "Welsh", native_name: "Cymraeg", script: "Latin", direction: "ltr" },
  
  // Middle Eastern & Central Asian
  { code: "fas", name: "Persian (Farsi)", native_name: "فارسی", script: "Arabic", direction: "rtl" },
  { code: "pus", name: "Pashto", native_name: "پښتو", script: "Arabic", direction: "rtl" },
  { code: "heb", name: "Hebrew", native_name: "עברית", script: "Hebrew", direction: "rtl" },
  { code: "urd", name: "Urdu", native_name: "اردو", script: "Arabic", direction: "rtl" },
  { code: "kur", name: "Kurdish", native_name: "Kurdî", script: "Arabic", direction: "rtl" },
  { code: "uig", name: "Uyghur", native_name: "ئۇيغۇرچە", script: "Arabic", direction: "rtl" },
  { code: "kaz", name: "Kazakh", native_name: "Қазақша", script: "Cyrillic", direction: "ltr" },
  { code: "uzb", name: "Uzbek", native_name: "Oʻzbekcha", script: "Latin", direction: "ltr" },
  { code: "tgk", name: "Tajik", native_name: "Тоҷикӣ", script: "Cyrillic", direction: "ltr" },
  { code: "azj", name: "Azerbaijani", native_name: "Azərbaycan", script: "Latin", direction: "ltr" },
  { code: "kat", name: "Georgian", native_name: "ქართული", script: "Georgian", direction: "ltr" },
  { code: "hye", name: "Armenian", native_name: "Հայերdelays", script: "Armenian", direction: "ltr" },
  
  // South Asian
  { code: "tam", name: "Tamil", native_name: "தமிழ்", script: "Tamil", direction: "ltr" },
  { code: "tel", name: "Telugu", native_name: "తెలుగు", script: "Telugu", direction: "ltr" },
  { code: "mar", name: "Marathi", native_name: "मराठी", script: "Devanagari", direction: "ltr" },
  { code: "guj", name: "Gujarati", native_name: "ગુજરાતી", script: "Gujarati", direction: "ltr" },
  { code: "kan", name: "Kannada", native_name: "ಕನ್ನಡ", script: "Kannada", direction: "ltr" },
  { code: "mal", name: "Malayalam", native_name: "മലയാളം", script: "Malayalam", direction: "ltr" },
  { code: "pan", name: "Punjabi", native_name: "ਪੰਜਾਬੀ", script: "Gurmukhi", direction: "ltr" },
  { code: "sin", name: "Sinhala", native_name: "සිංහල", script: "Sinhala", direction: "ltr" },
  { code: "nep", name: "Nepali", native_name: "नेपाली", script: "Devanagari", direction: "ltr" },
  { code: "san", name: "Sanskrit", native_name: "संस्कृतम्", script: "Devanagari", direction: "ltr" },
  
  // Southeast Asian
  { code: "tha", name: "Thai", native_name: "ไทย", script: "Thai", direction: "ltr" },
  { code: "mya", name: "Burmese", native_name: "မြန်မာ", script: "Myanmar", direction: "ltr" },
  { code: "khm", name: "Khmer", native_name: "ភាសាខ្មែរ", script: "Khmer", direction: "ltr" },
  { code: "lao", name: "Lao", native_name: "ລາວ", script: "Lao", direction: "ltr" },
  { code: "fil", name: "Filipino (Tagalog)", native_name: "Filipino", script: "Latin", direction: "ltr" },
  { code: "msa", name: "Malay", native_name: "Bahasa Melayu", script: "Latin", direction: "ltr" },
  { code: "jav", name: "Javanese", native_name: "Basa Jawa", script: "Latin", direction: "ltr" },
  
  // African languages
  { code: "swa", name: "Swahili", native_name: "Kiswahili", script: "Latin", direction: "ltr" },
  { code: "amh", name: "Amharic", native_name: "አማርኛ", script: "Ethiopic", direction: "ltr" },
  { code: "hau", name: "Hausa", native_name: "Hausa", script: "Latin", direction: "ltr" },
  { code: "yor", name: "Yoruba", native_name: "Yorùbá", script: "Latin", direction: "ltr" },
  { code: "ig", name: "Igbo", native_name: "Asụsụ Igbo", script: "Latin", direction: "ltr" },
  { code: "zul", name: "Zulu", native_name: "isiZulu", script: "Latin", direction: "ltr" },
  { code: "xho", name: "Xhosa", native_name: "isiXhosa", script: "Latin", direction: "ltr" },
  { code: "afr", name: "Afrikaans", native_name: "Afrikaans", script: "Latin", direction: "ltr" },
  { code: "som", name: "Somali", native_name: "Soomaali", script: "Latin", direction: "ltr" },
  
  // Indigenous & Less Common
  { code: "nav", name: "Navajo (Diné)", native_name: "Diné bizaad", script: "Latin", direction: "ltr" },
  { code: "ain", name: "Ainu", native_name: "アイヌ イタㇰ", script: "Katakana", direction: "ltr" },
  { code: "mri", name: "Māori", native_name: "Te Reo Māori", script: "Latin", direction: "ltr" },
  { code: "haw", name: "Hawaiian", native_name: "ʻŌlelo Hawaiʻi", script: "Latin", direction: "ltr" },
  { code: "smo", name: "Samoan", native_name: "Gagana Samoa", script: "Latin", direction: "ltr" },
  { code: "que", name: "Quechua", native_name: "Runasimi", script: "Latin", direction: "ltr" },
  { code: "aym", name: "Aymara", native_name: "Aymar aru", script: "Latin", direction: "ltr" },
  { code: "grn", name: "Guaraní", native_name: "Avañe'ẽ", script: "Latin", direction: "ltr" },
  { code: "bre", name: "Breton", native_name: "Brezhoneg", script: "Latin", direction: "ltr" },
  { code: "baq", name: "Basque", native_name: "Euskara", script: "Latin", direction: "ltr" },
  { code: "glg", name: "Galician", native_name: "Galego", script: "Latin", direction: "ltr" },
  
  // Classical & Historical
  { code: "lat", name: "Latin", native_name: "Lingua Latina", script: "Latin", direction: "ltr" },
  { code: "grc", name: "Ancient Greek", native_name: "Ἑλληνική", script: "Greek", direction: "ltr" },
  { code: "egy", name: "Egyptian (Ancient)", native_name: "Egyptian", script: "Hieroglyphic", direction: "ltr" },
  
  // Sign Languages (noted but limited text support)
  { code: "ase", name: "American Sign Language", native_name: "ASL", script: "Other", direction: "ltr" },
];

// Get language by code
export const getLanguageByCode = (code) => {
  return ALL_LANGUAGES.find(l => l.code === code || l.code === code.toLowerCase());
};

// Search languages
export const searchLanguages = (query) => {
  const q = query.toLowerCase();
  return ALL_LANGUAGES.filter(l => 
    l.code.toLowerCase().includes(q) ||
    l.name.toLowerCase().includes(q) ||
    (l.native_name && l.native_name.toLowerCase().includes(q))
  );
};
